import { Link } from "@shopify/hydrogen";

const ImageGrid = (props) => {
  return (
    <div className="max-w-[1220px] md:flex md:flex-row grid grid-cols-2 md:gap-x-5 md:gap-y-5 gap-x-2.5 gap-y-6 xl:px-0 px-4 md:mt-16">
      {props.data?.map((item, index) => (
        <div key={index}>
          <div className="relative max-w-[289px]">
            <Link to={item.imageLink}>
              <picture>
                <source media="(min-width:768px)" srcSet={item.desktopImage} />
                <img src={item.mobileImage} alt="image-grid-1" />
              </picture>
            </Link>
          </div>
          <div className="flex flex-wrap flex-col mt-[15px] md:px-[20px] px-0 text-[#2A3238] text-[14px] font-gotham-light">
            <Link className="hover:underline w-fit" to={item.categoryOneLink}>{item.categoryOne}</Link>
            {item.categoryTwo && (
              <Link className="hover:underline w-fit" to={item.categoryTwoLink}>{item.categoryTwo}</Link>
            )}
            <Link className="hover:underline w-fit" to={item.viewAllLink}>{item.viewAll}</Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
